
export function useGenericText() {
  const { t } = useI18n()
  
  return { 
    textFixtures: t('shared.seo.fixtures'),
    textResults: t('shared.seo.results'),
    textTable: t('shared.seo.table'),
    textStatistics: t('shared.seo.statistics'),
    textAll: t('shared.seo.all'),
    textHome: t('shared.seo.home'),
    textAway: t('shared.seo.away'),
  }
}

export function useVarsTeam() {
  const { t } = useI18n()
  const teamStore = useTeamStore()

  // Season name without year
  const seasonName = teamStore.season?.name?.replace(teamStore.season?.year, '')?.trim()

  // Team colors with translatons (lower case)
  const teamColors = (teamStore.colors || 'black,white')
    .split(',')
    .map(color => t(`shared.colors.${color}`).toLowerCase())

  return { 
    domain: useDomain(),
    sport: '{REMOVE}',
    teamName: teamStore?.name,
    teamSlug: teamStore?.slug,
    teamSeoName: teamStore?.seoName,
    teamFullName: teamStore?.fullName,
    teamNickname: teamStore?.nickname,
    teamManager: teamStore?.manager,
    teamColors: usePrettyJoin(teamColors, ',', '&'),
    
    // seasonTitle: '{season_title}', // teamStore.season?.title, // '<b>{seasonTitle}</b>',
    seasonName: seasonName,
    seasonNames: seasonName,
    seasonYear: teamStore.season?.year,
  }
}

export function useVarsGame(game) {
  const { t } = useI18n()
  const dayjs = useDayjs()
  const startingAt = dayjs(game.startDate).local(useEnv('locale')).tz(useEnv('timezone'))
  
  return {
    'tz': useEnv('timezone'),
    'locale': useEnv('locale'),
    'home': game.home?.name,
    'away': game.away?.name,
    'season': `${game.season?.name} ${game.season?.year}`,
    'seasonName': game.season?.name?.replace(game.season?.year, '')?.trim(),
    'seasonYear': game.season?.year,
    'date': startingAt.format('HH:mm ddd D MMM YYYY'),
  }
}

export function useTeamParams() {
  return {
    ...useVarsTeam(),
    ...useGenericText()
  }
}

export function useGameParams(game) {
  return {
    ...useVarsGame(game),
    ...useGenericText()
  }
}